'use client';
import React from 'react';
import DashboardLayout from '@/components/DashboardLayout';
import NotificationsContent from '../notifications/components/NotificationsContent';

export default function AdminNotificationsPage() {
  return (
    <DashboardLayout role="admin">
      <NotificationsContent role="admin" />
    </DashboardLayout>
  );
}
